import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		mainContainer: {
			height        : "100vh",
			display       : "flex",
			flexDirection : "column",
			overflow      : "hidden",
			alignItems    : "center"
		},
		topHeader: {
			backgroundColor : theme.other.colors.dialog.primary,
			display         : "flex",
			alignItems      : "center",
			padding         : "0rem 2.5rem",
			justifyContent  : "space-between",
			height          : "80px",
			borderBottom    : theme.other.darkMode ? undefined : `1px solid ${ theme.other.colors.input.primary }`

		},
		tabsRoot: {
			// flex          : "1",
			overflow : "hidden",
			height   : "100%"
			// marginBottom : "80px"
		},
		loginButton: {
		},
		tab: {
			fontWeight           : "500",
			padding              : "1.75rem 1rem",
			backgroundColor      : "transparent !important",
			color                : theme.other.colors.text.secondary,
			borderWidth          : "0",
			borderColor          : "transparent",
			flexGrow             : "1",
			width                : "100px",
			position             : "relative",
			"& span > div > div" : {
				overflow     : "hidden",
				textOverflow : "ellipsis",
				width        : "100%"
			},
			"&[data-active]": {
				"::after": {
					content         : "' '",
					position        : "absolute",
					bottom          : "0",
					left            : "0",
					width           : "100%",
					height          : "4px",
					backgroundColor : theme.other.darkMode ? "white" : theme.other.paletteNew.primaryDarkBlue,
					borderRadius    : "1rem 1rem 0 0"
				},
				color                : theme.other.darkMode ? theme.other.colors.text.primary : theme.other.paletteNew.primaryDarkBlue,
				minWidth             : "unset",
				"& span > div > div" : {
					width: "100%"
				}
			}
		},
		tabName: {
			color: "inherit"
		},
		tabsList: {
			border                 : "none",
			backgroundColor        : theme.other.colors.dialog.primary,
			flexWrap               : "nowrap",
			overflowX              : "scroll",
			display                : "flex",
			"&::-webkit-scrollbar" : {
				width   : "0",
				display : "none"
			}
		},
		tabLabel: {
			overflow: "hidden"
		},
		panel: {
			height   : "100%",
			overflow : "auto"
		},
		innerContainer: {
		},
		priorityBox: {
			display      : "flex",
			alignItems   : "center",
			background   : theme.other.paletteNew.primaryLightBlue,
			margin       : "1.5rem",
			borderRadius : "1.5rem"
		},
		itemCard: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			width          : "100%",
			borderBottom   : `1px solid ${ theme.other.colors.input.primary }`,
			padding        : "1.5rem 1rem",
			paddingRight   : "2rem"

		},
		loginButtonContainer: {
			padding: "1rem"
		},
		bottomContainer: {
			borderTop : theme.other.darkMode ? undefined : `1px solid ${ theme.other.colors.input.primary }`,
			position  : "fixed",
			bottom    : "0",
			width     : "100%",
			left      : "50%",
			transform : "translate(-50%,0)",
			maxWidth  : "450px"

		},
		selfCardContainer: {
			backgroundColor: theme.other.colors.dialog.primary
		},
		playGameContainer: {
			margin         : "2rem auto",
			display        : "flex",
			borderRadius   : "50%",
			width          : "fit-content",
			alignItems     : "center",
			justifyContent : "center"
		},
		playGameButton: {
			borderRadius : "50rem !important",
			border       : `1px solid ${ theme.other.paletteNew.secondaryWhite } !important`,
			boxShadow    : theme.other.colors.boxShadow.primary,
			padding      : "1rem 2rem"

		},
		playGameIcon: {
			borderRadius : "1rem",
			width        : "3rem",
			height       : "3rem",
			objectFit    : "cover"
		},
		listContainer: {
			display       : "flex",
			flexDirection : "column",
			marginBottom  : "18rem"
		},
		itemPhoto: {
			borderRadius : "100%",
			height       : "4rem",
			width        : "4rem"
		},
		itemPhotoContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"
		},
		itemLeft: {
			display    : "flex",
			gap        : "1.5rem",
			alignItems : "center"

		},
		itemRight: {
		},
		donationContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			gap            : "0.5rem"
		},
		donationText: {
			color: theme.other.colors.text.secondary
		},
		donation: {
			// minWidth: "50px"
		},
		drawerInner: {
			maxWidth: "450px"
		},
		infoContainer: {
			padding: "1.6rem"
		},
		drawerContent: {
			backgroundColor : theme.other.colors.dialog.secondary,
			borderRadius    : "2rem 2rem 0 0",
			height          : "unset"
		},
		drawerHeader: {
			width           : "100%",
			backgroundColor : theme.other.colors.dialog.primary,
			padding         : "1.5rem 2rem",
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "space-between"
		},
		infoItem: {
			color: theme.other.colors.text.secondary
		},
		infoList: {
			margin       : "0",
			marginBottom : "1rem",
			paddingLeft  : "3rem"
		},
		rank: {
			color          : theme.other.colors.text.secondary,
			fontWeight     : "500",
			minWidth       : "4rem",
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"
		},
		trophyImage: {
			height   : "100%",
			width    : "unset",
			minWidth : "100px"
		},
		topContent: {
			padding: "1rem"
		},
		dominationHeading: {
			height    : "100%",
			objectFit : "contain",
			padding   : "1rem 5rem"
		},
		container: {
			maxWidth      : "450px",
			width         : "100%",
			height        : "100vh",
			overflow      : "hidden",
			display       : "flex",
			flexDirection : "column"
		},
		topBanner: {
			borderRadius: "1.5rem"
		},
		bannerContainer: {
			padding: "2rem"
		},
		tabIcon: {
			width        : "4rem",
			height       : "4rem",
			objectFit    : "cover",
			borderRadius : "1rem"

		},
		leaderboardsContainer: {
			backgroundColor: theme.other.colors.background.secondary
		},
		leaderboardsCardImage: {
			height    : "220px",
			objectFit : "cover"
		},
		leaderboardsCard: {
			borderRadius    : "1.5rem",
			margin          : "1.6rem",
			backgroundColor : theme.other.colors.background.primary,
			borderWidth     : "1px",
			borderColor     : theme.other.colors.dialog.primary,
			borderStyle     : "solid"

		},
		cardTextContainer: {
			padding: "1rem"
		},
		viewLeaderboardsButton: {
			borderRadius : "100rem",
			height       : "4rem"
		},
		viewLeaderboardsButtonText: {
			fontSize: "1.4rem"
		},
		leaderboardsInner: {
			overflow: "auto"
		},
		actionIcon: {
			width     : "unset",
			height    : "unset",
			"&:hover" : {
				backgroundColor: "transparent"
			}
		}
	};
} );